import { Epic, combineEpics, ofType } from "redux-observable";
import { mergeMap, withLatestFrom } from "rxjs";
import { IAction } from "../../../interface/action.interface";
import { IRootState } from "../../../redux/root.reducer";
import { hasAccessToHistoricalSnapshots } from "../../../service/user-permission";
import { historicalSnapshotGetAction } from "./historical-snapshots/historical-snapshots.actions";
import { historicalSnapshotEpic } from "./historical-snapshots/historical-snapshots.epic";
import { listDetailsGetAction } from "./list-details/list-details.actions";
import { listDetailsEpic } from "./list-details/list-details.epic";
import { IInitListDetailsAction, ListActionType } from "./list-page.actions";
import { sublistGetAction } from "./sublists/sublists.actions";
import { sublistEpic } from "./sublists/sublists.epic";

const epic: Epic<IAction, IAction, IRootState> = (action$, state$) =>
    action$.pipe(
        ofType<IInitListDetailsAction, ListActionType.LIST_PAGE_INIT>(
            ListActionType.LIST_PAGE_INIT,
        ),
        withLatestFrom(state$),
        mergeMap(([{ payload }, { auth }]) => [
            listDetailsGetAction(payload.listId),
            sublistGetAction(payload.listId),
            ...(hasAccessToHistoricalSnapshots(auth.user?.role)
                ? [historicalSnapshotGetAction(payload.listId)]
                : []),
        ]),
    );

export const listPageEpic = combineEpics<IAction, IAction, IRootState>(
    epic,
    listDetailsEpic,
    historicalSnapshotEpic,
    sublistEpic,
);
